module.exports = __webpack_public_path__ + "static/media/successProfile.2522a1f5.svg";